import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";

export default function Button(props) {
  return (
    <button
      onClick={props.onClick}
      className="rounded-md p-3 text-xl tracking-wide font-bold text-white bg-ciGreen-light hover:bg-ciGreen-medium"
    >
      {props.icon && (
        <span className="pr-3">
          <FontAwesomeIcon
            icon={
              props.icon === "faCalendarAlt" ? faCalendarAlt : faCalendarAlt
            }
          />
        </span>
      )}
      {props.text}
    </button>
  );
}
